import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../services/api';
import ImageUploader from '../components/ImageUploader';
import { 
  Rocket, Briefcase, User, Image, Palette, Utensils, Dumbbell, ShoppingCart, Cloud, PartyPopper, Home as HomeIcon,
  Lock, Sparkles, Check, FileText, ImageIcon, MousePointer, Lightbulb,
  BarChart3, Link as LinkIcon, Video, Megaphone, Quote, Mail, Minus, Timer, HelpCircle, Users, Building2,
  Smartphone, MapPin, Bookmark, Calendar, SlidersHorizontal, MessageSquareText, Pencil, Eye, ExternalLink, Save, Trash2, ChevronUp, ChevronDown, FileIcon,
  Facebook, Instagram, Twitter, Linkedin, Youtube, Music, Github, MessageCircle, DollarSign, GalleryHorizontalEnd,
  PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen, GripVertical, Menu, X, Plus, Copy, ArrowLeft, Layers, Settings2
} from 'lucide-react';

// VERSION 2: Templates + Stats + Pricing + Gallery + YouTube + Drag & Drop + Lucide Icons

const sectionTemplates = [
  {
    id: 'landing',
    name: 'Landing Page',
    icon: Rocket,
    desc: 'Hero + Features + CTA',
    blocks: [
      { type: 'hero', data: { title: 'Transformez votre business', subtitle: 'La solution tout-en-un pour réussir en ligne', bgGradient: 'from-indigo-600 to-purple-700', textColor: '#ffffff' }},
      { type: 'features', data: { items: [
        { icon: 'zap', title: 'Ultra rapide', desc: 'Performance optimale garantie' },
        { icon: 'lock', title: 'Sécurisé', desc: 'Vos données sont protégées' },
        { icon: 'target', title: 'Efficace', desc: 'Résultats mesurables' }
      ]}},
      { type: 'cta', data: { title: 'Prêt à démarrer ?', subtitle: 'Rejoignez des milliers de clients satisfaits', buttonText: 'Commencer gratuitement', buttonUrl: '#contact', bgGradient: 'from-green-500 to-emerald-600' }}
    ]
  },
  {
    id: 'services',
    name: 'Services',
    icon: Briefcase,
    desc: 'Présentation + Pricing',
    blocks: [
      { type: 'hero', data: { title: 'Nos Services', subtitle: 'Des solutions adaptées à vos besoins', bgGradient: 'from-blue-600 to-cyan-500', textColor: '#ffffff' }},
      { type: 'pricing', data: { plans: [
        { name: 'Starter', price: '29F', period: '/mois', features: ['5 projets', 'Support email', '1 Go stockage'], highlighted: false },
        { name: 'Pro', price: '79F', period: '/mois', features: ['Projets illimités', 'Support prioritaire', '50 Go', 'API'], highlighted: true },
        { name: 'Enterprise', price: 'Sur devis', period: '', features: ['Tout illimité', 'Support dédié', 'SLA'], highlighted: false }
      ]}}
    ]
  },
  {
    id: 'about',
    name: 'À propos',
    icon: User,
    desc: 'Stats + Témoignage',
    blocks: [
      { type: 'paragraph', data: { text: 'Nous sommes une équipe passionnée dédiée à votre réussite. Depuis notre création, nous avons aidé des centaines d\'entreprises à atteindre leurs objectifs.', fontSize: '20', textAlign: 'center' }},
      { type: 'stats', data: { items: [
        { value: '500+', label: 'Clients' },
        { value: '99%', label: 'Satisfaction' },
        { value: '24/7', label: 'Support' },
        { value: '10 ans', label: 'Expérience' }
      ]}},
      { type: 'testimonial', data: { quote: 'Une équipe exceptionnelle qui a transformé notre vision en réalité.', author: 'Marie Dupont', role: 'CEO, TechCorp' }}
    ]
  },
  {
    id: 'portfolio',
    name: 'Portfolio',
    icon: Image,
    desc: 'Galerie + Contact',
    blocks: [
      { type: 'hero', data: { title: 'Nos Réalisations', subtitle: 'Découvrez nos projets', bgGradient: 'from-pink-500 to-orange-500', textColor: '#ffffff' }},
      { type: 'gallery', data: { images: [], columns: 3 }},
      { type: 'contact_form', data: { title: 'Un projet ? Parlons-en !', buttonText: 'Envoyer' }}
    ]
  },
  {
    id: 'startup',
    name: 'Startup',
    icon: Sparkles,
    desc: 'Hero vidéo + Stats + CTA',
    blocks: [
      { type: 'hero', data: { title: 'L\'innovation à votre service', subtitle: 'Découvrez la prochaine génération de solutions digitales', bgGradient: 'from-violet-600 to-fuchsia-600', textColor: '#ffffff' }},
      { type: 'youtube', data: { url: '', aspect: '16/9' }},
      { type: 'stats', data: { items: [
        { value: '10MF', label: 'Levée de fonds' },
        { value: '50K+', label: 'Utilisateurs' },
        { value: '15', label: 'Pays' },
        { value: '#1', label: 'Du marché' }
      ]}},
      { type: 'cta', data: { title: 'Rejoignez la révolution', subtitle: 'Les premiers inscrits bénéficient de -50%', buttonText: 'Essayer gratuitement', buttonUrl: '#signup', bgGradient: 'from-violet-600 to-fuchsia-600' }}
    ]
  },
  {
    id: 'agency',
    name: 'Agence Créative',
    icon: Palette,
    desc: 'Hero + Portfolio + Équipe',
    blocks: [
      { type: 'hero', data: { title: 'Créativité sans limites', subtitle: 'Design • Branding • Digital', bgGradient: 'from-rose-500 to-amber-500', textColor: '#ffffff' }},
      { type: 'paragraph', data: { text: 'Nous transformons vos idées en expériences visuelles mémorables. Notre équipe de créatifs passionnés repousse les limites du design.', fontSize: '20', textAlign: 'center' }},
      { type: 'gallery', data: { images: [], columns: 4 }},
      { type: 'features', data: { items: [
        { icon: 'palette', title: 'Design UI/UX', desc: 'Interfaces modernes et intuitives' },
        { icon: 'smartphone', title: 'Mobile First', desc: 'Adapté à tous les écrans' },
        { icon: 'rocket', title: 'Performance', desc: 'Sites ultra-rapides' }
      ]}}
    ]
  },
  {
    id: 'restaurant',
    name: 'Restaurant',
    icon: Utensils,
    desc: 'Menu + Galerie + Réservation',
    blocks: [
      { type: 'hero', data: { title: 'Saveurs d\'exception', subtitle: 'Une expérience culinaire unique', bgGradient: 'from-amber-600 to-red-700', textColor: '#ffffff' }},
      { type: 'features', data: { items: [
        { icon: 'utensils', title: 'Entrées', desc: 'À partir de 12F' },
        { icon: 'utensils-crossed', title: 'Plats', desc: 'À partir de 24F' },
        { icon: 'cake', title: 'Desserts', desc: 'À partir de 9F' }
      ]}},
      { type: 'gallery', data: { images: [], columns: 3 }},
      { type: 'divider', data: { style: 'wave', spacing: 'md' }},
      { type: 'contact_form', data: { title: 'Réserver une table', buttonText: 'Réserver' }}
    ]
  },
  {
    id: 'coach',
    name: 'Coach / Formateur',
    icon: Dumbbell,
    desc: 'Présentation + Témoignages + Contact',
    blocks: [
      { type: 'hero', data: { title: 'Atteignez vos objectifs', subtitle: 'Coaching personnalisé pour votre réussite', bgGradient: 'from-teal-500 to-cyan-600', textColor: '#ffffff' }},
      { type: 'paragraph', data: { text: 'Avec plus de 10 ans d\'expérience, je vous accompagne dans votre transformation personnelle et professionnelle. Ma méthode unique a déjà aidé des centaines de personnes à dépasser leurs limites.', fontSize: '18', textAlign: 'center' }},
      { type: 'stats', data: { items: [
        { value: '300+', label: 'Clients coachés' },
        { value: '98%', label: 'Réussite' },
        { value: '5⭐', label: 'Avis clients' },
        { value: '10 ans', label: 'Expérience' }
      ]}},
      { type: 'testimonial', data: { quote: 'Grâce à ce coaching, j\'ai doublé mon chiffre d\'affaires en 6 mois !', author: 'Thomas L.', role: 'Entrepreneur' }},
      { type: 'pricing', data: { plans: [
        { name: 'Découverte', price: '97F', period: '/session', features: ['1h de coaching', 'Plan d\'action', 'Suivi email'], highlighted: false },
        { name: 'Transformation', price: '497F', period: '/mois', features: ['4 sessions/mois', 'Accès communauté', 'Support WhatsApp', 'Ressources exclusives'], highlighted: true },
        { name: 'VIP', price: '1997F', period: '/mois', features: ['Sessions illimitées', 'Accès premium', 'Coaching 24/7', 'Masterclass privées'], highlighted: false }
      ]}}
    ]
  },
  {
    id: 'ecommerce',
    name: 'E-commerce',
    icon: ShoppingCart,
    desc: 'Produits + Promo + Trust',
    blocks: [
      { type: 'hero', data: { title: 'Nouvelle Collection 2026', subtitle: '-30% sur tout le site | Livraison gratuite', bgGradient: 'from-slate-800 to-slate-900', textColor: '#ffffff' }},
      { type: 'features', data: { items: [
        { icon: 'truck', title: 'Livraison Express', desc: '24-48h partout en France' },
        { icon: 'rotate-ccw', title: 'Retours Gratuits', desc: '30 jours pour changer d\'avis' },
        { icon: 'lock', title: 'Paiement Sécurisé', desc: 'CB, PayPal, Apple Pay' }
      ]}},
      { type: 'gallery', data: { images: [], columns: 4 }},
      { type: 'stats', data: { items: [
        { value: '50K+', label: 'Clients' },
        { value: '4.8/5', label: 'Note moyenne' },
        { value: '100K+', label: 'Produits vendus' },
        { value: '24h', label: 'Livraison' }
      ]}},
      { type: 'cta', data: { title: 'Profitez des soldes !', subtitle: 'Offre limitée - Stock limité', buttonText: 'Voir la collection', buttonUrl: '#shop', bgGradient: 'from-red-600 to-orange-500' }}
    ]
  },
  {
    id: 'saas',
    name: 'SaaS / App',
    icon: Cloud,
    desc: 'Features + Pricing + FAQ',
    blocks: [
      { type: 'hero', data: { title: 'Simplifiez votre workflow', subtitle: 'L\'outil tout-en-un pour les équipes modernes', bgGradient: 'from-blue-600 to-indigo-700', textColor: '#ffffff' }},
      { type: 'features', data: { items: [
        { icon: 'bar-chart-3', title: 'Dashboard intuitif', desc: 'Visualisez vos données en temps réel' },
        { icon: 'link', title: 'Intégrations', desc: 'Connectez +100 applications' },
        { icon: 'bot', title: 'IA intégrée', desc: 'Automatisez vos tâches' }
      ]}},
      { type: 'stats', data: { items: [
        { value: '10K+', label: 'Équipes' },
        { value: '99.9%', label: 'Uptime' },
        { value: '4.9⭐', label: 'Sur G2' },
        { value: '150+', label: 'Pays' }
      ]}},
      { type: 'pricing', data: { plans: [
        { name: 'Free', price: '0F', period: '/mois', features: ['3 utilisateurs', '1 Go stockage', 'Support communauté'], highlighted: false },
        { name: 'Team', price: '29F', period: '/utilisateur/mois', features: ['Utilisateurs illimités', '100 Go', 'Support prioritaire', 'SSO'], highlighted: true },
        { name: 'Enterprise', price: 'Custom', period: '', features: ['Tout illimité', 'On-premise option', 'SLA 99.99%', 'Account manager'], highlighted: false }
      ]}},
      { type: 'cta', data: { title: 'Essai gratuit 14 jours', subtitle: 'Aucune carte bancaire requise', buttonText: 'Démarrer maintenant', buttonUrl: '#signup', bgGradient: 'from-green-500 to-emerald-600' }}
    ]
  },
  {
    id: 'event',
    name: 'Événement',
    icon: PartyPopper,
    desc: 'Date + Programme + Inscription',
    blocks: [
      { type: 'hero', data: { title: 'Tech Summit 2026', subtitle: '15-16 Mars • Paris La Défense', bgGradient: 'from-purple-600 to-blue-600', textColor: '#ffffff' }},
      { type: 'stats', data: { items: [
        { value: '2000+', label: 'Participants' },
        { value: '50+', label: 'Speakers' },
        { value: '2', label: 'Jours' },
        { value: '30+', label: 'Workshops' }
      ]}},
      { type: 'features', data: { items: [
        { icon: 'mic', title: 'Conférences', desc: 'Les meilleurs experts du secteur' },
        { icon: 'handshake', title: 'Networking', desc: 'Rencontrez votre futur partenaire' },
        { icon: 'gift', title: 'Goodies', desc: 'Repartez avec des cadeaux exclusifs' }
      ]}},
      { type: 'pricing', data: { plans: [
        { name: 'Early Bird', price: '149F', period: '', features: ['Accès 2 jours', 'Lunch inclus', 'Goodies'], highlighted: false },
        { name: 'VIP', price: '399F', period: '', features: ['Accès 2 jours', 'Places réservées', 'Afterparty', 'Meet & Greet speakers'], highlighted: true },
        { name: 'Corporate', price: '999F', period: '/5 places', features: ['Pack 5 entrées', 'Stand networking', 'Visibilité logo'], highlighted: false }
      ]}},
      { type: 'contact_form', data: { title: 'Réservez votre place', buttonText: 'S\'inscrire' }}
    ]
  },
  {
    id: 'realestate',
    name: 'Immobilier',
    icon: HomeIcon,
    desc: 'Propriété + Galerie + Contact',
    blocks: [
      { type: 'hero', data: { title: 'Villa d\'exception', subtitle: '350m² • 5 chambres • Piscine • Vue mer', bgGradient: 'from-emerald-600 to-teal-700', textColor: '#ffffff' }},
      { type: 'gallery', data: { images: [], columns: 3 }},
      { type: 'features', data: { items: [
        { icon: 'bed', title: '5 Chambres', desc: 'Suites avec salle de bain' },
        { icon: 'waves', title: 'Piscine', desc: 'Chauffée toute l\'année' },
        { icon: 'trees', title: 'Jardin', desc: '2000m² paysager' }
      ]}},
      { type: 'stats', data: { items: [
        { value: '350m²', label: 'Surface' },
        { value: '2000m²', label: 'Terrain' },
        { value: '2022', label: 'Construction' },
        { value: 'A', label: 'DPE' }
      ]}},
      { type: 'cta', data: { title: '1 890 000 F', subtitle: 'Frais d\'agence inclus', buttonText: 'Demander une visite', buttonUrl: '#contact', bgGradient: 'from-amber-500 to-orange-600' }},
      { type: 'contact_form', data: { title: 'Contactez notre agent', buttonText: 'Envoyer ma demande' }}
    ]
  }
];

const blockPalette = [
  { type: 'header', label: 'Entête', icon: HomeIcon, desc: 'Navigation' },
  { type: 'hero', label: 'Hero', icon: Palette, desc: 'En-tête' },
  { type: 'paragraph', label: 'Texte', icon: FileText, desc: 'Paragraphe' },
  { type: 'image', label: 'Image', icon: ImageIcon, desc: 'Image' },
  { type: 'button', label: 'Bouton', icon: MousePointer, desc: 'Action' },
  { type: 'features', label: 'Features', icon: Sparkles, desc: '3 colonnes' },
  { type: 'stats', label: 'Stats', icon: BarChart3, desc: 'Chiffres' },
  { type: 'pricing', label: 'Tarifs', icon: DollarSign, desc: 'Prix' },
  { type: 'gallery', label: 'Galerie', icon: GalleryHorizontalEnd, desc: 'Photos' },
  { type: 'youtube', label: 'Vidéo', icon: Video, desc: 'YouTube' },
  { type: 'cta', label: 'CTA', icon: Megaphone, desc: 'Action' },
  { type: 'testimonial', label: 'Avis', icon: Quote, desc: 'Client' },
  { type: 'contact_form', label: 'Contact', icon: Mail, desc: 'Form' },
  { type: 'divider', label: 'Séparateur', icon: Minus, desc: 'Ligne' },
  { type: 'countdown', label: 'Countdown', icon: Timer, desc: 'Compte à rebours' },
  { type: 'faq', label: 'FAQ', icon: HelpCircle, desc: 'Questions' },
  { type: 'team', label: 'Équipe', icon: Users, desc: 'Membres' },
  { type: 'logos', label: 'Logos', icon: Building2, desc: 'Partenaires' },
  { type: 'social', label: 'Réseaux', icon: Smartphone, desc: 'Sociaux' },
  { type: 'map', label: 'Carte', icon: MapPin, desc: 'Google Maps' },
  { type: 'banner', label: 'Bannière', icon: Bookmark, desc: 'Promo' },
  { type: 'timeline', label: 'Timeline', icon: Calendar, desc: 'Chronologie' },
  { type: 'image_slider', label: 'Slider Images', icon: SlidersHorizontal, desc: 'Carrousel' },
  { type: 'text_slider', label: 'Slider Texte', icon: MessageSquareText, desc: 'Témoignages' },
];

const defaultBlockData = (type) => {
  switch(type){
    case 'header': return {
      style: 'modern',
      bgColor: '#ffffff',
      textColor: '#1f2937',
      sticky: true,
      showLogo: true,
      showNav: true,
      ctaText: 'Contact',
      ctaUrl: '#contact',
      ctaBgColor: '#4f46e5'
    };
    case 'hero': return { 
      title: 'Bienvenue sur notre site', 
      subtitle: 'Découvrez nos services exceptionnels', 
      bgGradient: 'from-indigo-600 to-purple-700', 
      textColor: '#ffffff' 
    };
    case 'paragraph': return { 
      text: 'Écrivez votre contenu ici...', 
      fontSize: '18', 
      textAlign: 'left' 
    };
    case 'image': return { url: '', alt: 'Image', borderRadius: '12', shadow: true };
    case 'button': return {
      text: 'Cliquez ici',
      url: '#',
      style: 'solid',
      size: 'lg',
      bgColor: '#4f46e5',
      textColor: '#ffffff',
      borderRadius: '12',
      icon: '',
      fullWidth: false,
      animated: true
    };
    case 'features': return { items: [
      { icon: 'rocket', title: 'Rapide', desc: 'Performance optimale' },
      { icon: 'lock', title: 'Sécurisé', desc: 'Données protégées' },
      { icon: 'gem', title: 'Premium', desc: 'Qualité pro' }
    ]};
    case 'stats': return { items: [
      { value: '100+', label: 'Clients' },
      { value: '50+', label: 'Projets' },
      { value: '99%', label: 'Satisfaction' },
      { value: '5⭐', label: 'Note' }
    ]};
    case 'pricing': return { plans: [
      { name: 'Basic', price: '19F', period: '/mois', features: ['Feature 1', 'Feature 2'], highlighted: false, buttonText: 'Choisir', buttonUrl: '#' },
      { name: 'Pro', price: '49F', period: '/mois', features: ['Tout Basic', 'Feature 3', 'Feature 4'], highlighted: true, buttonText: 'Choisir', buttonUrl: '#' },
      { name: 'Enterprise', price: '99F', period: '/mois', features: ['Tout Pro', 'Feature 5', 'Support dédié'], highlighted: false, buttonText: 'Choisir', buttonUrl: '#' }
    ]};
    case 'gallery': return { images: [], columns: 3 };
    case 'youtube': return { url: '', aspect: '16/9' };
    case 'cta': return { 
      title: 'Prêt à démarrer ?', 
      subtitle: 'Contactez-nous maintenant', 
      buttonText: 'Commencer', 
      buttonUrl: '#', 
      bgGradient: 'from-green-500 to-emerald-600' 
    };
    case 'testimonial': return { 
      quote: 'Un service exceptionnel !', 
      author: 'Client Satisfait', 
      role: 'CEO' 
    };
    case 'contact_form': return { 
      title: 'Contactez-nous', 
      buttonText: 'Envoyer' 
    };
    case 'divider': return { style: 'line', spacing: 'md' };
    case 'countdown': return { 
      targetDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], 
      title: 'Lancement dans', 
      bgGradient: 'from-red-500 to-orange-500' 
    };
    case 'faq': return { items: [
      { q: 'Comment ça marche ?', a: 'C\'est très simple ! Inscrivez-vous et commencez immédiatement.' },
      { q: 'Quels sont les tarifs ?', a: 'Nous proposons plusieurs formules adaptées à vos besoins.' },
      { q: 'Puis-je annuler ?', a: 'Oui, vous pouvez annuler à tout moment sans frais.' }
    ]};
    case 'team': return { members: [
      { name: 'Marie Dupont', role: 'CEO & Fondatrice', image: '', bio: 'Passionnée par l\'innovation' },
      { name: 'Jean Martin', role: 'CTO', image: '', bio: 'Expert technique' },
      { name: 'Sophie Bernard', role: 'Design Lead', image: '', bio: 'Créative et perfectionniste' }
    ]};
    case 'logos': return { 
      title: 'Ils nous font confiance', 
      logos: [], 
      grayscale: true,
      animation: 'scroll' 
    };
    case 'social': return { 
      style: 'icons', 
      links: [
        { platform: 'facebook', url: '#' },
        { platform: 'instagram', url: '#' },
        { platform: 'twitter', url: '#' },
        { platform: 'linkedin', url: '#' }
      ]
    };
    case 'map': return { 
      address: 'Paris, France', 
      zoom: 14, 
      height: 400 
    };
    case 'banner': return { 
      text: 'Offre spéciale -50% jusqu\'au 31 janvier !', 
      icon: 'party-popper',
      buttonText: 'En profiter', 
      buttonUrl: '#', 
      bgColor: '#ef4444',
      animated: true 
    };
    case 'timeline': return { events: [
      { year: '2020', title: 'Création', desc: 'Lancement de l\'entreprise' },
      { year: '2022', title: 'Croissance', desc: '1000 clients atteints' },
      { year: '2024', title: 'Expansion', desc: 'Ouverture internationale' },
      { year: '2026', title: 'Innovation', desc: 'Lancement V2' }
    ]};
    case 'image_slider': return { 
      slides: [
        { image: '', title: 'Slide 1', subtitle: 'Description du premier slide' },
        { image: '', title: 'Slide 2', subtitle: 'Description du deuxième slide' },
        { image: '', title: 'Slide 3', subtitle: 'Description du troisième slide' }
      ],
      autoplay: true,
      interval: 5,
      showDots: true,
      showArrows: true,
      height: 500
    };
    case 'text_slider': return { 
      slides: [
        { quote: 'Un service exceptionnel qui a transformé notre business !', author: 'Marie D.', role: 'CEO, TechCorp', avatar: '' },
        { quote: 'Je recommande à 100%. Équipe professionnelle et réactive.', author: 'Jean P.', role: 'Directeur Marketing', avatar: '' },
        { quote: 'La meilleure décision que nous ayons prise cette année.', author: 'Sophie L.', role: 'Fondatrice, StartupXYZ', avatar: '' }
      ],
      autoplay: true,
      interval: 4,
      style: 'cards'
    };
    default: return {};
  }
};

const ShowcaseEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [site, setSite] = useState(null);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [activePageId, setActivePageId] = useState(null);
  const [viewMode, setViewMode] = useState('edit');
  const [newPage, setNewPage] = useState({ titre: '', slug: '' });
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [showTemplates, setShowTemplates] = useState(false);
  const [draggedBlock, setDraggedBlock] = useState(null);
  const [showLeftPanel, setShowLeftPanel] = useState(true);
  const [showRightPanel, setShowRightPanel] = useState(true);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Detect mobile
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setShowLeftPanel(false);
        setShowRightPanel(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!id || id === 'undefined') { navigate('/showcase'); return; }
    load();
    // eslint-disable-next-line
  }, [id]);

  const load = async () => {
    try {
      const res = await api.get(`/showcase/sites/${id}`);
      setSite(res.data.site);
      setPages(res.data.pages || []);
      if (!activePageId && res.data.pages?.length) setActivePageId(res.data.pages[0].id);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const updateSite = async (updates) => {
    setSaving(true);
    try {
      await api.put(`/showcase/sites/${id}`, updates);
      setSite({ ...site, ...updates });
    } catch (e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const activePage = pages.find(p => p.id === activePageId);
  const primaryColor = site?.primary_color || '#4f46e5';

  const togglePublish = async () => {
    setPublishing(true);
    try {
      await api.put(`/showcase/sites/${id}/publish`, { is_published: !site.is_published });
      setSite({ ...site, is_published: site.is_published ? 0 : 1 });
    } catch (e) { alert('Erreur'); }
    finally { setPublishing(false); }
  };

  const addPage = async (e) => {
    e.preventDefault();
    if (!newPage.titre || !newPage.slug) return;
    try {
      const res = await api.post(`/showcase/sites/${id}/pages`, newPage);
      await load();
      setActivePageId(res.data.id);
      setNewPage({ titre: '', slug: '' });
    } catch (e) { alert(e.response?.data?.error || 'Erreur'); }
  };

  const deletePage = async (pageId) => {
    // Empêcher la suppression s'il ne reste qu'une page
    if (pages.length <= 1) {
      alert('Vous devez avoir au moins une page');
      return;
    }
    if (!window.confirm('Supprimer cette page et tout son contenu ?')) return;
    try {
      await api.delete(`/showcase/pages/${pageId}`);
      // Si on supprime la page active, basculer sur la première page restante
      if (activePageId === pageId) {
        const remaining = pages.filter(p => p.id !== pageId);
        if (remaining.length > 0) {
          setActivePageId(remaining[0].id);
        }
      }
      setPages(pages.filter(p => p.id !== pageId));
    } catch (e) { alert(e.response?.data?.error || 'Erreur lors de la suppression'); }
  };

  const updatePage = async (page) => {
    if (!page || !page.id) {
      console.error('updatePage: page ou page.id undefined', page);
      return;
    }
    setSaving(true);
    try { 
      await api.put(`/showcase/pages/${page.id}`, page);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 2000);
    }
    catch (e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const addBlock = (type) => {
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const blocks = Array.isArray(page.blocks_json) ? [...page.blocks_json] : [];
    blocks.push({ id: Date.now(), type, data: defaultBlockData(type) });
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setSelectedBlock(blocks.length - 1);
    if (isMobile) {
      setShowLeftPanel(false);
      setShowRightPanel(true);
    }
  };

  const duplicateBlock = (index) => {
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const blocks = [...(page.blocks_json || [])];
    const clone = JSON.parse(JSON.stringify(blocks[index]));
    clone.id = Date.now();
    blocks.splice(index + 1, 0, clone);
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setSelectedBlock(index + 1);
  };

  const blockLabel = (type) => {
    const found = blockPalette.find(b => b.type === type);
    return found ? found.label : type;
  };

  const updateBlock = (index, data) => {
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const blocks = [...(page.blocks_json || [])];
    blocks[index] = { ...blocks[index], data };
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
  };

  const moveBlock = (index, dir) => {
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const blocks = [...(page.blocks_json || [])];
    const newIndex = index + dir;
    if (newIndex < 0 || newIndex >= blocks.length) return;
    [blocks[index], blocks[newIndex]] = [blocks[newIndex], blocks[index]];
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setSelectedBlock(newIndex);
  };

  const removeBlock = (index) => {
    if (!activePage || !activePage.id) return;
    if (!window.confirm('Supprimer ce bloc ?')) return;
    const page = { ...activePage };
    const blocks = [...(page.blocks_json || [])];
    blocks.splice(index, 1);
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setSelectedBlock(null);
  };

  const applyTemplate = (template) => {
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const existingBlocks = Array.isArray(page.blocks_json) ? [...page.blocks_json] : [];
    const newBlocks = template.blocks.map(b => ({ id: Date.now() + Math.random(), type: b.type, data: { ...b.data } }));
    page.blocks_json = [...existingBlocks, ...newBlocks];
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setShowTemplates(false);
  };

  const handleDragStart = (e, index) => {
    setDraggedBlock(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedBlock === null || draggedBlock === index) return;
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedBlock === null || draggedBlock === index) return;
    if (!activePage || !activePage.id) return;
    const page = { ...activePage };
    const blocks = [...(page.blocks_json || [])];
    const [removed] = blocks.splice(draggedBlock, 1);
    blocks.splice(index, 0, removed);
    page.blocks_json = blocks;
    updatePage(page);
    setPages(pages.map(p => p.id === page.id ? page : p));
    setDraggedBlock(null);
    setSelectedBlock(index);
  };

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      {/* Top Bar */}
      <div className="bg-gray-800 border-b border-gray-700 px-3 md:px-4 py-2 md:py-3">
        <div className="flex items-center justify-between gap-2">
          {/* Left: Back + Title */}
          <div className="flex items-center gap-2 md:gap-4 min-w-0">
            <Link to="/showcase" className="text-gray-400 hover:text-white flex-shrink-0 p-1">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            {/* Mobile: sidebar toggle */}
            {viewMode === 'edit' && (
              <button 
                onClick={() => { setShowLeftPanel(!showLeftPanel); if (isMobile) setShowRightPanel(false); }}
                className="md:hidden text-gray-400 hover:text-white p-1 flex-shrink-0"
              >
                <Menu className="w-5 h-5" />
              </button>
            )}
            <div className="min-w-0">
              <h1 className="text-white font-bold text-sm md:text-base truncate">{site?.titre}</h1>
              <span className={`text-xs px-2 py-0.5 rounded-full ${site?.is_published ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                {site?.is_published ? '● En ligne' : '○ Brouillon'}
              </span>
            </div>
          </div>

          {/* Center: Edit/Preview toggle */}
          <div className="bg-gray-700 rounded-lg p-0.5 md:p-1 flex flex-shrink-0">
            <button onClick={() => setViewMode('edit')} className={`px-2 md:px-3 py-1 md:py-1.5 rounded text-xs md:text-sm flex items-center gap-1 transition-colors ${viewMode === 'edit' ? 'bg-indigo-600 text-white' : 'text-gray-400 hover:text-gray-200'}`}>
              <Pencil className="w-3.5 h-3.5 md:w-4 md:h-4" /> <span className="hidden sm:inline">Éditer</span>
            </button>
            <button onClick={() => setViewMode('preview')} className={`px-2 md:px-3 py-1 md:py-1.5 rounded text-xs md:text-sm flex items-center gap-1 transition-colors ${viewMode === 'preview' ? 'bg-indigo-600 text-white' : 'text-gray-400 hover:text-gray-200'}`}>
              <Eye className="w-3.5 h-3.5 md:w-4 md:h-4" /> <span className="hidden sm:inline">Aperçu</span>
            </button>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-1.5 md:gap-3 flex-shrink-0">
            {/* Save indicator */}
            {(saving || saveSuccess) && (
              <span className={`text-xs px-2 py-1 rounded-full flex items-center gap-1 transition-all ${
                saving ? 'bg-yellow-500/20 text-yellow-400' : 'bg-green-500/20 text-green-400'
              }`}>
                {saving ? <><Save className="w-3 h-3 animate-pulse" /> <span className="hidden sm:inline">Sauvegarde...</span></> : <><Check className="w-3 h-3" /> <span className="hidden sm:inline">Sauvé</span></>}
              </span>
            )}

            {site?.is_published && (
              <a href={`/site/${site.slug}`} target="_blank" rel="noreferrer" className="p-1.5 md:px-3 md:py-1.5 bg-gray-700 text-white rounded text-sm flex items-center gap-1 hover:bg-gray-600 transition">
                <ExternalLink className="w-4 h-4" /> <span className="hidden md:inline">Voir</span>
              </a>
            )}

            <button onClick={togglePublish} disabled={publishing} className={`px-2.5 md:px-4 py-1.5 rounded font-medium text-xs md:text-sm flex items-center gap-1 transition-colors ${site?.is_published ? 'bg-gray-600 hover:bg-gray-500 text-white' : 'bg-green-600 hover:bg-green-500 text-white'}`}>
              {publishing ? '...' : (site?.is_published ? <><Lock className="w-3.5 h-3.5 md:w-4 md:h-4" /> <span className="hidden sm:inline">Dépublier</span></> : <><Rocket className="w-3.5 h-3.5 md:w-4 md:h-4" /> <span className="hidden sm:inline">Publier</span></>)}
            </button>
          </div>
        </div>
      </div>

      <div className="flex-1 flex overflow-hidden relative">
        {/* Mobile overlay backdrop */}
        {isMobile && (showLeftPanel || showRightPanel) && (
          <div 
            className="absolute inset-0 bg-black/50 z-30 md:hidden" 
            onClick={() => { setShowLeftPanel(false); setShowRightPanel(false); }} 
          />
        )}

        {/* Sidebar gauche */}
        {viewMode === 'edit' && (
          <div className={`${
            isMobile 
              ? `absolute left-0 top-0 bottom-0 z-40 transition-transform duration-300 ${showLeftPanel ? 'translate-x-0' : '-translate-x-full'}` 
              : `${showLeftPanel ? 'w-64' : 'w-0'} transition-all duration-300`
          } bg-gray-800 border-r border-gray-700 flex flex-col ${isMobile ? 'w-72' : ''}`} style={!isMobile && !showLeftPanel ? { overflow: 'hidden', borderRight: 'none' } : {}}>
            {/* Panel header with close */}
            <div className="p-3 border-b border-gray-700 flex items-center justify-between flex-shrink-0">
              <span className="text-xs text-white font-semibold uppercase tracking-wider flex items-center gap-2"><Layers className="w-4 h-4 text-indigo-400" /> Panneau</span>
              <button onClick={() => setShowLeftPanel(false)} className="text-gray-400 hover:text-white p-1 rounded hover:bg-gray-700 transition">
                {isMobile ? <X className="w-4 h-4" /> : <PanelLeftClose className="w-4 h-4" />}
              </button>
            </div>
            <div className="flex-1 overflow-y-auto">
              {/* Pages */}
              <div className="p-4 border-b border-gray-700">
                <div className="text-xs text-gray-400 uppercase mb-2 flex items-center gap-1"><FileIcon className="w-3 h-3" /> Pages</div>
                {pages.map(p => (
                  <div key={p.id} className="group relative mb-1">
                    <button 
                      onClick={() => setActivePageId(p.id)} 
                      className={`w-full text-left px-3 py-2 rounded pr-8 flex items-center gap-2 ${activePageId === p.id ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`}
                    >
                      <FileIcon className="w-4 h-4" /> {p.titre}
                    </button>
                    {/* Bouton supprimer - visible au survol ou si page active */}
                    {pages.length > 1 && (
                      <button
                        onClick={(e) => { e.stopPropagation(); deletePage(p.id); }}
                        className={`absolute right-1 top-1/2 -translate-y-1/2 p-1.5 rounded transition-all ${
                          activePageId === p.id 
                            ? 'text-white/70 hover:text-white hover:bg-white/20' 
                            : 'text-gray-500 hover:text-red-400 hover:bg-gray-600 opacity-0 group-hover:opacity-100'
                        }`}
                        title="Supprimer la page"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                ))}
                {pages.length < 7 && (
                  <form onSubmit={addPage} className="mt-3 space-y-2">
                    <input className="w-full px-2 py-1.5 bg-gray-700 border border-gray-600 rounded text-white text-sm" placeholder="Titre" value={newPage.titre} onChange={e => setNewPage({...newPage, titre: e.target.value})} />
                    <input className="w-full px-2 py-1.5 bg-gray-700 border border-gray-600 rounded text-white text-sm" placeholder="identifiant de la page (ex: accueil)" value={newPage.slug} onChange={e => setNewPage({...newPage, slug: e.target.value.toLowerCase().replace(/\s+/g, '-')})} />
                    <button className="w-full py-1.5 bg-indigo-600 text-white rounded text-sm">+ Ajouter</button>
                  </form>
                )}
              </div>

              {/* Blocs */}
              <div className="p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="text-xs text-gray-400 uppercase flex items-center gap-1"><Plus className="w-3 h-3" /> Ajouter un bloc</div>
                </div>
                <button onClick={() => setShowTemplates(true)} className="w-full mb-3 text-xs px-3 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg flex items-center justify-center gap-2 hover:shadow-lg hover:shadow-purple-500/25 transition-all hover:scale-[1.02]">
                  <Sparkles className="w-3.5 h-3.5" /> Utiliser un template
                </button>
                <div className="grid grid-cols-3 gap-1.5">
                  {blockPalette.map(b => {
                    const BlockIcon = b.icon;
                    return (
                      <button 
                        key={b.type} 
                        onClick={() => addBlock(b.type)} 
                        className="flex flex-col items-center p-2 bg-gray-700/80 hover:bg-indigo-600/80 rounded-lg text-xs text-gray-300 hover:text-white transition-all group" 
                        title={b.desc}
                      >
                        <BlockIcon className="w-4.5 h-4.5 md:w-5 md:h-5 group-hover:scale-110 transition-transform" />
                        <span className="mt-1 truncate w-full text-center text-[10px] md:text-xs">{b.label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Style rapide - toujours visible en bas */}
            <div className="p-4 border-t border-gray-700 bg-gray-800/90 backdrop-blur flex-shrink-0">
              <div className="text-xs text-gray-400 uppercase mb-2 flex items-center gap-1"><Palette className="w-3 h-3" /> Style global</div>
              <div className="flex items-center gap-3">
                <div className="relative">
                  <input type="color" value={primaryColor} onChange={e => updateSite({ primary_color: e.target.value })} className="w-10 h-10 rounded-lg cursor-pointer border-2 border-gray-600" />
                </div>
                <span className="text-gray-300 text-sm">Couleur principale</span>
              </div>
              <div className="mt-3">
                <ImageUploader value={site?.logo_url || ''} onChange={url => updateSite({ logo_url: url })} label="Logo" />
              </div>
            </div>
          </div>
        )}

        {/* Zone principale */}
        <div className="flex-1 overflow-y-auto bg-gray-100">
          {/* Desktop toggle buttons for panels */}
          {viewMode === 'edit' && !isMobile && (
            <>
              {!showLeftPanel && (
                <button 
                  onClick={() => setShowLeftPanel(true)} 
                  className="fixed left-2 top-1/2 -translate-y-1/2 z-20 p-2 bg-gray-800 text-gray-400 hover:text-white rounded-r-lg shadow-lg transition-all hover:bg-gray-700"
                  title="Ouvrir le panneau"
                >
                  <PanelLeftOpen className="w-4 h-4" />
                </button>
              )}
            </>
          )}

          {viewMode === 'preview' ? (
            <LivePreview site={site} page={activePage} pages={pages} primaryColor={primaryColor} />
          ) : (
            <div className="max-w-4xl mx-auto py-4 md:py-8 px-3 md:px-4">
              {!activePage ? (
                <div className="text-center py-20 text-gray-400">Sélectionnez une page</div>
              ) : (
                <>
                  <input 
                    className="text-2xl md:text-3xl font-bold text-gray-900 bg-transparent w-full mb-4 md:mb-6 outline-none focus:ring-2 focus:ring-indigo-200 rounded-lg px-2 py-1 -ml-2 transition" 
                    value={activePage.titre} 
                    onChange={e => {
                      const p = {...activePage, titre: e.target.value};
                      setPages(pages.map(x => x.id === p.id ? p : x));
                    }}
                    onBlur={() => updatePage(activePage)}
                    placeholder="Titre de la page"
                  />

                  {(activePage.blocks_json || []).length === 0 ? (
                    <div className="text-center py-16 bg-white rounded-xl border-2 border-dashed border-gray-300">
                      <Sparkles className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                      <div className="text-gray-600 mb-4">Ajoutez des blocs depuis le panneau de gauche</div>
                      <button onClick={() => setShowTemplates(true)} className="px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-medium inline-flex items-center gap-2">
                        <Rocket className="w-4 h-4" /> Utiliser un template
                      </button>
                    </div>
                  ) : (
                    <div className="space-y-3 md:space-y-4">
                      {(activePage.blocks_json || []).map((blk, idx) => {
                        const PaletteItem = blockPalette.find(b => b.type === blk.type);
                        const BlockTypeIcon = PaletteItem?.icon || Layers;
                        return (
                          <div 
                            key={blk.id} 
                            draggable={!isMobile}
                            onDragStart={e => handleDragStart(e, idx)}
                            onDragOver={e => handleDragOver(e, idx)}
                            onDrop={e => handleDrop(e, idx)}
                            onDragEnd={() => setDraggedBlock(null)}
                            onClick={() => { setSelectedBlock(idx); if (isMobile) setShowRightPanel(true); }}
                            className={`relative rounded-xl overflow-hidden transition group ${
                              isMobile ? 'cursor-pointer' : 'cursor-move'
                            } ${
                              draggedBlock === idx ? 'opacity-50 scale-95' : ''
                            } ${selectedBlock === idx ? 'ring-2 ring-indigo-500 shadow-lg shadow-indigo-500/10' : 'hover:ring-2 hover:ring-gray-300'}`}
                          >
                            {/* Block type label */}
                            <div className={`absolute top-2 left-2 z-10 flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs font-medium transition-all ${
                              selectedBlock === idx 
                                ? 'bg-indigo-600 text-white shadow-lg' 
                                : 'bg-white/90 backdrop-blur text-gray-600 shadow opacity-0 group-hover:opacity-100'
                            }`}>
                              {!isMobile && <GripVertical className="w-3 h-3 opacity-50" />}
                              <BlockTypeIcon className="w-3.5 h-3.5" />
                              <span>{blockLabel(blk.type)}</span>
                            </div>

                            {/* Toolbar */}
                            <div className={`absolute top-2 right-2 z-10 flex gap-1 transition-all ${
                              selectedBlock === idx ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                            }`}>
                              <button onClick={e => { e.stopPropagation(); moveBlock(idx, -1); }} className="p-1.5 bg-white rounded-lg shadow-md text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 transition" title="Monter"><ChevronUp className="w-4 h-4" /></button>
                              <button onClick={e => { e.stopPropagation(); moveBlock(idx, 1); }} className="p-1.5 bg-white rounded-lg shadow-md text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 transition" title="Descendre"><ChevronDown className="w-4 h-4" /></button>
                              <button onClick={e => { e.stopPropagation(); duplicateBlock(idx); }} className="p-1.5 bg-white rounded-lg shadow-md text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition" title="Dupliquer"><Copy className="w-4 h-4" /></button>
                              <button onClick={e => { e.stopPropagation(); removeBlock(idx); }} className="p-1.5 bg-white rounded-lg shadow-md text-red-500 hover:text-red-700 hover:bg-red-50 transition" title="Supprimer"><Trash2 className="w-4 h-4" /></button>
                            </div>
                            <BlockPreview block={blk} primaryColor={primaryColor} />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
              {/* Mobile FAB: add block */}
              {isMobile && viewMode === 'edit' && activePage && (
                <button 
                  onClick={() => { setShowLeftPanel(true); setShowRightPanel(false); }}
                  className="fixed bottom-20 right-4 z-30 w-14 h-14 bg-indigo-600 text-white rounded-full shadow-xl flex items-center justify-center hover:bg-indigo-500 active:scale-95 transition-all"
                >
                  <Plus className="w-6 h-6" />
                </button>
              )}
            </div>
          )}
        </div>

        {/* Sidebar droite - paramètres bloc */}
        {viewMode === 'edit' && selectedBlock !== null && activePage?.blocks_json?.[selectedBlock] && (
          <div className={`${
            isMobile 
              ? `absolute right-0 top-0 bottom-0 z-40 transition-transform duration-300 ${showRightPanel ? 'translate-x-0' : 'translate-x-full'}` 
              : `${showRightPanel ? 'w-72 lg:w-80' : 'w-0'} transition-all duration-300`
          } bg-white border-l border-gray-200 flex flex-col ${isMobile ? 'w-[85vw] max-w-sm shadow-2xl' : ''}`} style={!isMobile && !showRightPanel ? { overflow: 'hidden', borderLeft: 'none' } : {}}>
            <div className="p-3 md:p-4 border-b flex justify-between items-center flex-shrink-0 sticky top-0 bg-white z-10">
              <div className="flex items-center gap-2">
                <Settings2 className="w-4 h-4 text-indigo-600" />
                <span className="font-semibold text-sm md:text-base">Paramètres</span>
                {activePage?.blocks_json?.[selectedBlock] && (
                  <span className="text-xs px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-700">
                    {blockLabel(activePage.blocks_json[selectedBlock].type)}
                  </span>
                )}
              </div>
              <button onClick={() => { setSelectedBlock(null); if (isMobile) setShowRightPanel(false); }} className="text-gray-400 hover:text-gray-600 p-1 rounded hover:bg-gray-100 transition">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-3 md:p-4 overflow-y-auto flex-1">
              <BlockSettings 
                block={activePage.blocks_json[selectedBlock]} 
                onChange={data => updateBlock(selectedBlock, data)} 
                primaryColor={primaryColor}
              />
            </div>
          </div>
        )}
      </div>

      {/* Modal Templates */}
      {showTemplates && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end md:items-center justify-center md:p-4 backdrop-blur-sm">
          <div className="bg-white rounded-t-2xl md:rounded-2xl w-full md:max-w-4xl max-h-[90vh] md:max-h-[85vh] overflow-hidden shadow-2xl">
            <div className="p-4 md:p-6 border-b flex justify-between items-center bg-gradient-to-r from-purple-600 to-pink-600">
              <div>
                <h2 className="text-lg md:text-xl font-bold text-white flex items-center gap-2"><Sparkles className="w-5 h-5" /> Templates</h2>
                <p className="text-xs md:text-sm text-white/80">12 modèles professionnels prêts à l'emploi</p>
              </div>
              <button onClick={() => setShowTemplates(false)} className="p-2 hover:bg-white/20 rounded-lg text-white">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-3 md:p-6 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 overflow-y-auto max-h-[65vh]">
              {sectionTemplates.map(t => {
                const TemplateIcon = t.icon;
                return (
                  <button 
                    key={t.id} 
                    onClick={() => { applyTemplate(t); if (isMobile) setShowLeftPanel(false); }}
                    className="text-left p-3 md:p-4 border-2 border-gray-200 rounded-xl hover:border-indigo-500 hover:bg-gradient-to-br hover:from-indigo-50 hover:to-purple-50 transition-all group hover:shadow-lg active:scale-95 md:hover:scale-[1.02]"
                  >
                    <div className="flex items-center gap-2 mb-2 md:mb-3">
                      <TemplateIcon className="w-6 h-6 md:w-8 md:h-8 text-indigo-600 flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <div className="font-bold text-gray-900 group-hover:text-indigo-600 truncate text-sm md:text-base">{t.name}</div>
                        <div className="text-[10px] md:text-xs text-gray-500">{t.desc}</div>
                      </div>
                    </div>
                    <div className="flex gap-1 flex-wrap">
                      {t.blocks.slice(0, 4).map((b, i) => {
                        const BlockPaletteItem = blockPalette.find(bp => bp.type === b.type);
                        const BlockItemIcon = BlockPaletteItem?.icon;
                        return (
                          <span key={i} className="text-xs px-1.5 py-0.5 bg-gray-100 group-hover:bg-white rounded text-gray-600">
                            {BlockItemIcon && <BlockItemIcon className="w-3 h-3 inline" />}
                          </span>
                        );
                      })}
                      {t.blocks.length > 4 && (
                        <span className="text-xs px-1.5 py-0.5 bg-indigo-100 text-indigo-600 rounded">+{t.blocks.length - 4}</span>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
            <div className="p-3 md:p-4 bg-gray-50 border-t flex items-center justify-between">
              <span className="text-xs md:text-sm text-gray-500 flex items-center gap-1"><Lightbulb className="w-4 h-4" /> <span className="hidden sm:inline">Les blocs seront ajoutés à la suite de votre page</span><span className="sm:hidden">Ajoutés à la suite</span></span>
              <button onClick={() => setShowTemplates(false)} className="px-3 md:px-4 py-2 text-gray-600 hover:text-gray-900 text-sm">
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Preview live
const LivePreview = ({ site, page, pages, primaryColor }) => {
  if (!site || !page) return null;
  
  return (
    <div style={{ fontFamily: site.font_family || 'Inter' }}>
      {/* Header */}
      <header className="bg-white shadow-sm py-4 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            {site.logo_url && <img src={site.logo_url} alt="" className="h-10 w-10 object-contain rounded" />}
            <span className="text-xl font-bold" style={{ color: primaryColor }}>{site.titre}</span>
          </div>
          <nav className="flex gap-4">
            {pages.map(p => <span key={p.id} className="text-gray-600">{p.titre}</span>)}
          </nav>
        </div>
      </header>

      {/* Content */}
      {(page.blocks_json || []).map((blk, idx) => (
        <BlockPreview key={idx} block={blk} primaryColor={primaryColor} />
      ))}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 text-center">
        <p className="text-gray-400">© 2026 {site.titre}</p>
      </footer>
    </div>
  );
};

// Preview d'un bloc
const BlockPreview = ({ block, primaryColor }) => {
  const { type, data } = block;

  switch(type) {
    case 'header':
      return (
        <div 
          className="px-4 py-3 flex items-center justify-between" 
          style={{ backgroundColor: data.bgColor || '#ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}
        >
          <div className="flex items-center gap-3">
            {data.showLogo && (
              <div 
                className="w-9 h-9 bg-gradient-to-br from-indigo-500 to-purple-600" 
                style={{ borderRadius: '10px' }}
              />
            )}
            <span className="font-bold text-lg" style={{ color: data.textColor || '#1f2937' }}>Logo</span>
          </div>
          {data.showNav && (
            <nav className="hidden md:flex items-center gap-1">
              {['Accueil', 'Services', 'Contact'].map((item, i) => (
                <span 
                  key={i}
                  className={`px-3 py-1.5 cursor-pointer transition-all ${i === 0 ? 'font-semibold' : 'opacity-70 hover:opacity-100'}`}
                  style={{ color: data.textColor || '#1f2937', borderRadius: '6px' }}
                >
                  {item}
                  {i === 0 && (
                    <span 
                      className="block mx-auto mt-0.5 w-4 h-0.5" 
                      style={{ backgroundColor: data.ctaBgColor || '#4f46e5', borderRadius: '2px' }}
                    />
                  )}
                </span>
              ))}
            </nav>
          )}
          <div className="flex items-center gap-2">
            {data.ctaText && (
              <button 
                className="px-4 py-2 text-white font-semibold text-sm transition-transform hover:scale-105" 
                style={{ backgroundColor: data.ctaBgColor || '#4f46e5', borderRadius: '8px' }}
              >
                {data.ctaText}
              </button>
            )}
            {/* Mobile menu icon preview */}
            <div className="md:hidden flex flex-col gap-1 p-2">
              <span className="w-4 h-0.5" style={{ backgroundColor: data.textColor || '#1f2937' }} />
              <span className="w-4 h-0.5" style={{ backgroundColor: data.textColor || '#1f2937' }} />
              <span className="w-4 h-0.5" style={{ backgroundColor: data.textColor || '#1f2937' }} />
            </div>
          </div>
        </div>
      );

    case 'button':
      const btnStyles = {
        solid: { backgroundColor: data.bgColor || '#4f46e5', color: data.textColor || '#ffffff', border: 'none' },
        outline: { backgroundColor: 'transparent', color: data.bgColor || '#4f46e5', border: `2px solid ${data.bgColor || '#4f46e5'}` },
        ghost: { backgroundColor: 'transparent', color: data.bgColor || '#4f46e5', border: 'none' },
        gradient: { background: `linear-gradient(135deg, ${data.bgColor || '#4f46e5'}, ${data.bgColor2 || '#9333ea'})`, color: data.textColor || '#ffffff', border: 'none' }
      };
      const sizeClasses = { sm: 'px-4 py-2 text-sm', md: 'px-6 py-3 text-base', lg: 'px-8 py-4 text-lg', xl: 'px-10 py-5 text-xl' };
      return (
        <div className="py-8 px-6 flex justify-center">
          <a
            href={data.url || '#'}
            className={`inline-flex items-center gap-2 font-semibold ${sizeClasses[data.size || 'lg']} ${data.animated ? 'hover:scale-105 transition-transform' : ''} ${data.fullWidth ? 'w-full justify-center' : ''}`}
            style={{ ...btnStyles[data.style || 'solid'], borderRadius: `${data.borderRadius || 12}px` }}
          >
            {data.icon && <span>{data.icon}</span>}
            {data.text || 'Bouton'}
          </a>
        </div>
      );

    case 'hero':
      return (
        <div className={`py-20 px-6 text-center bg-gradient-to-br ${data.bgGradient || 'from-indigo-600 to-purple-700'}`}>
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: data.textColor || '#fff' }}>{data.title}</h1>
          <p className="text-xl opacity-90" style={{ color: data.textColor || '#fff' }}>{data.subtitle}</p>
        </div>
      );

    case 'paragraph':
      return (
        <div className="py-10 px-6">
          <div className="max-w-3xl mx-auto">
            <p style={{ fontSize: `${data.fontSize || 18}px`, textAlign: data.textAlign || 'left' }} className="text-gray-700 leading-relaxed">
              {data.text}
            </p>
          </div>
        </div>
      );

    case 'image':
      return data.url ? (
        <div className="py-8 px-6">
          <div className="max-w-4xl mx-auto">
            <img src={data.url} alt={data.alt || ''} className={`w-full ${data.shadow ? 'shadow-xl' : ''}`} style={{ borderRadius: `${data.borderRadius || 12}px` }} />
          </div>
        </div>
      ) : (
        <div className="py-8 px-6">
          <div className="max-w-4xl mx-auto h-48 bg-gray-200 rounded-xl flex items-center justify-center text-gray-400 gap-2">
            <ImageIcon className="w-6 h-6" /> Image
          </div>
        </div>
      );

    case 'features':
      return (
        <div className="py-16 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            {(data.items || []).map((item, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-sm text-center">
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      );

    case 'cta':
      return (
        <div className={`py-16 px-6 text-center bg-gradient-to-r ${data.bgGradient || 'from-green-500 to-emerald-600'}`}>
          <h2 className="text-3xl font-bold text-white mb-2">{data.title}</h2>
          <p className="text-white/80 mb-6">{data.subtitle}</p>
          <a href={data.buttonUrl || '#'} className="inline-block px-8 py-3 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100">
            {data.buttonText}
          </a>
        </div>
      );

    case 'testimonial':
      return (
        <div className="py-16 px-6">
          <div className="max-w-3xl mx-auto text-center">
            <div className="text-5xl text-gray-300 mb-4">"</div>
            <p className="text-2xl text-gray-700 italic mb-6">{data.quote}</p>
            <div className="font-bold text-gray-900">{data.author}</div>
            <div className="text-gray-500">{data.role}</div>
          </div>
        </div>
      );

    case 'contact_form':
      return (
        <div className="py-16 px-6 bg-gray-50">
          <div className="max-w-xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">{data.title}</h2>
            <div className="space-y-4">
              <input className="w-full px-4 py-3 border rounded-lg" placeholder="Nom" disabled />
              <input className="w-full px-4 py-3 border rounded-lg" placeholder="Email" disabled />
              <textarea className="w-full px-4 py-3 border rounded-lg" rows={4} placeholder="Message" disabled />
              <button className="w-full py-3 text-white rounded-lg font-semibold" style={{ backgroundColor: primaryColor }}>
                {data.buttonText}
              </button>
            </div>
          </div>
        </div>
      );

    case 'stats':
      return (
        <div className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
            {(data.items || []).map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-4xl md:text-5xl font-bold" style={{ color: primaryColor }}>{stat.value}</div>
                <div className="text-gray-600 mt-2">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      );

    case 'pricing':
      return (
        <div className="py-16 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
            {(data.plans || []).map((plan, i) => (
              <div key={i} className={`p-6 rounded-2xl ${plan.highlighted ? 'bg-gradient-to-br from-indigo-600 to-purple-700 text-white ring-4 ring-indigo-300 scale-105' : 'bg-white shadow-lg'}`}>
                <div className={`text-lg font-semibold ${plan.highlighted ? 'text-white' : 'text-gray-900'}`}>{plan.name}</div>
                <div className="mt-4 flex items-baseline">
                  <span className="text-4xl font-bold">{plan.price}</span>
                  <span className={`ml-1 ${plan.highlighted ? 'text-white/70' : 'text-gray-500'}`}>{plan.period}</span>
                </div>
                <ul className="mt-6 space-y-3">
                  {(plan.features || []).map((f, j) => (
                    <li key={j} className="flex items-center gap-2">
                      <Check className={`w-4 h-4 ${plan.highlighted ? 'text-green-300' : 'text-green-500'}`} />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a 
                  href={plan.buttonUrl || '#'}
                  className={`block w-full mt-6 py-3 rounded-lg font-semibold text-center ${plan.highlighted ? 'bg-white text-indigo-600 hover:bg-gray-100' : 'bg-indigo-600 text-white hover:bg-indigo-700'} transition`}
                >
                  {plan.buttonText || 'Choisir'}
                </a>
              </div>
            ))}
          </div>
        </div>
      );

    case 'gallery':
      const cols = data.columns || 3;
      return (
        <div className="py-12 px-6">
          <div className={`max-w-6xl mx-auto grid gap-4`} style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
            {(data.images || []).length > 0 ? (
              data.images.map((img, i) => (
                <div key={i} className="aspect-square rounded-xl overflow-hidden bg-gray-100">
                  <img src={img} alt="" className="w-full h-full object-cover hover:scale-105 transition" />
                </div>
              ))
            ) : (
              Array(cols * 2).fill(0).map((_, i) => (
                <div key={i} className="aspect-square rounded-xl bg-gray-200 flex items-center justify-center text-gray-400">
                  <ImageIcon className="w-8 h-8" />
                </div>
              ))
            )}
          </div>
        </div>
      );

    case 'youtube':
      const getYoutubeId = (url) => {
        const match = url?.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/);
        return match ? match[1] : null;
      };
      const videoId = getYoutubeId(data.url);
      return (
        <div className="py-12 px-6">
          <div className="max-w-4xl mx-auto">
            {videoId ? (
              <div className="relative rounded-xl overflow-hidden shadow-xl" style={{ aspectRatio: data.aspect || '16/9' }}>
                <iframe 
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title="YouTube"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
              </div>
            ) : (
              <div className="aspect-video bg-gray-200 rounded-xl flex items-center justify-center text-gray-500 gap-2">
                <Video className="w-6 h-6" /> Collez une URL YouTube
              </div>
            )}
          </div>
        </div>
      );

    case 'divider':
      const spacing = { sm: 'py-4', md: 'py-8', lg: 'py-12' };
      return (
        <div className={`${spacing[data.spacing || 'md']} px-6`}>
          {data.style === 'line' && <hr className="max-w-4xl mx-auto border-gray-200" />}
          {data.style === 'dots' && (
            <div className="flex justify-center gap-2">
              <span className="w-2 h-2 rounded-full bg-gray-300"></span>
              <span className="w-2 h-2 rounded-full bg-gray-300"></span>
              <span className="w-2 h-2 rounded-full bg-gray-300"></span>
            </div>
          )}
          {data.style === 'wave' && (
            <svg viewBox="0 0 1200 50" className="w-full max-w-4xl mx-auto text-gray-200" fill="currentColor">
              <path d="M0,25 Q300,0 600,25 T1200,25 V50 H0 Z" />
            </svg>
          )}
        </div>
      );

    case 'countdown':
      const calculateTimeLeft = () => {
        const target = new Date(data.targetDate).getTime();
        const now = Date.now();
        const diff = target - now;
        if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0 };
        return {
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          mins: Math.floor((diff / (1000 * 60)) % 60),
          secs: Math.floor((diff / 1000) % 60)
        };
      };
      const timeLeft = calculateTimeLeft();
      return (
        <div className={`py-12 px-6 text-center bg-gradient-to-r ${data.bgGradient || 'from-red-500 to-orange-500'}`}>
          <h3 className="text-xl text-white/90 mb-4">{data.title}</h3>
          <div className="flex justify-center gap-4">
            {[['days', 'Jours'], ['hours', 'Heures'], ['mins', 'Min'], ['secs', 'Sec']].map(([key, label]) => (
              <div key={key} className="bg-white/20 backdrop-blur rounded-xl p-4 min-w-[80px]">
                <div className="text-4xl font-bold text-white animate-pulse">{timeLeft[key]}</div>
                <div className="text-white/70 text-sm">{label}</div>
              </div>
            ))}
          </div>
        </div>
      );

    case 'faq':
      return (
        <div className="py-16 px-6 bg-gray-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">Questions fréquentes</h2>
            <div className="space-y-4">
              {(data.items || []).map((item, i) => (
                <div key={i} className="bg-white rounded-xl shadow-sm overflow-hidden">
                  <div className="p-4 font-semibold text-gray-900 flex items-center justify-between cursor-pointer hover:bg-gray-50">
                    <span>{item.q}</span>
                    <span className="text-indigo-500 text-xl">+</span>
                  </div>
                  <div className="px-4 pb-4 text-gray-600">{item.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );

    case 'team':
      return (
        <div className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Notre équipe</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {(data.members || []).map((m, i) => (
                <div key={i} className="text-center group">
                  <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 overflow-hidden ring-4 ring-white shadow-lg group-hover:scale-110 transition">
                    {m.image ? <img src={m.image} alt={m.name} className="w-full h-full object-cover" /> : (
                      <div className="w-full h-full flex items-center justify-center text-white"><User className="w-10 h-10" /></div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{m.name}</h3>
                  <p className="text-indigo-600 font-medium">{m.role}</p>
                  <p className="text-gray-500 text-sm mt-2">{m.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      );

    case 'logos':
      return (
        <div className="py-12 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            {data.title && <h3 className="text-center text-gray-500 mb-8">{data.title}</h3>}
            <div className={`flex items-center justify-center gap-12 flex-wrap ${data.animation === 'scroll' ? 'animate-marquee' : ''}`}>
              {(data.logos || []).length > 0 ? (
                data.logos.map((logo, i) => (
                  <img key={i} src={logo} alt="" className={`h-12 object-contain ${data.grayscale ? 'grayscale hover:grayscale-0' : ''} transition opacity-60 hover:opacity-100`} />
                ))
              ) : (
                ['Google', 'Meta', 'Apple', 'Amazon', 'Netflix'].map((name, i) => (
                  <div key={i} className={`h-10 px-6 bg-gray-300 rounded flex items-center justify-center text-gray-500 font-bold ${data.grayscale ? 'grayscale' : ''}`}>{name}</div>
                ))
              )}
            </div>
          </div>
        </div>
      );

    case 'social':
      const SocialIconPreview = ({ platform }) => {
        const icons = {
          facebook: Facebook, instagram: Instagram, twitter: Twitter, linkedin: Linkedin,
          youtube: Youtube, tiktok: Music, github: Github, discord: MessageCircle
        };
        const Icon = icons[platform] || LinkIcon;
        return <Icon className="w-6 h-6" />;
      };
      return (
        <div className="py-8 px-6">
          <div className="flex justify-center gap-4">
            {(data.links || []).map((link, i) => (
              <a key={i} href={link.url} className="w-12 h-12 rounded-full bg-gray-100 hover:bg-indigo-100 flex items-center justify-center text-gray-600 hover:text-indigo-600 transition hover:scale-110">
                <SocialIconPreview platform={link.platform} />
              </a>
            ))}
          </div>
        </div>
      );

    case 'map':
      return (
        <div className="py-8 px-6">
          <div className="max-w-4xl mx-auto rounded-xl overflow-hidden shadow-lg" style={{ height: data.height || 400 }}>
            <iframe
              title="Map"
              src={`https://www.google.com/maps?q=${encodeURIComponent(data.address || 'Paris')}&z=${data.zoom || 14}&output=embed`}
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      );

    case 'banner':
      return (
        <div 
          className={`py-3 px-6 text-center ${data.animated ? 'animate-pulse' : ''}`} 
          style={{ backgroundColor: data.bgColor || '#ef4444' }}
        >
          <div className="max-w-4xl mx-auto flex items-center justify-center gap-4 flex-wrap">
            <span className="text-white font-medium">{data.text}</span>
            {data.buttonText && (
              <a href={data.buttonUrl || '#'} className="px-4 py-1 bg-white text-gray-900 rounded-full text-sm font-semibold hover:bg-gray-100 transition">
                {data.buttonText}
              </a>
            )}
          </div>
        </div>
      );

    case 'timeline':
      return (
        <div className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Notre histoire</h2>
            <div className="relative">
              <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full" />
              {(data.events || []).map((evt, i) => (
                <div key={i} className={`relative flex items-center mb-8 ${i % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-5/12 ${i % 2 === 0 ? 'text-right pr-8' : 'text-left pl-8'}`}>
                    <div className="bg-white p-4 rounded-xl shadow-lg hover:shadow-xl transition">
                      <div className="text-2xl font-bold text-indigo-600">{evt.year}</div>
                      <div className="font-semibold text-gray-900">{evt.title}</div>
                      <div className="text-gray-500 text-sm">{evt.desc}</div>
                    </div>
                  </div>
                  <div className="w-2/12 flex justify-center">
                    <div className="w-4 h-4 bg-indigo-500 rounded-full ring-4 ring-white shadow" />
                  </div>
                  <div className="w-5/12" />
                </div>
              ))}
            </div>
          </div>
        </div>
      );

    case 'image_slider':
      return <ImageSliderPreview data={data} primaryColor={primaryColor} />;

    case 'text_slider':
      return <TextSliderPreview data={data} primaryColor={primaryColor} />;

    default:
      return <div className="py-8 text-center text-gray-400">Bloc: {type}</div>;
  }
};

// Composant Slider Images avec state interne
const ImageSliderPreview = ({ data, primaryColor }) => {
  const [current, setCurrent] = React.useState(0);
  const slides = data.slides || [];
  
  React.useEffect(() => {
    if (!data.autoplay || slides.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, (data.interval || 5) * 1000);
    return () => clearInterval(timer);
  }, [data.autoplay, data.interval, slides.length]);

  const prev = () => setCurrent(c => (c - 1 + slides.length) % slides.length);
  const next = () => setCurrent(c => (c + 1) % slides.length);

  return (
    <div className="relative overflow-hidden" style={{ height: data.height || 500 }}>
      {/* Slides */}
      <div className="relative w-full h-full">
        {slides.map((slide, i) => (
          <div 
            key={i}
            className={`absolute inset-0 transition-all duration-700 ease-in-out ${
              i === current ? 'opacity-100 translate-x-0' : 
              i < current ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'
            }`}
          >
            {slide.image ? (
              <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-indigo-500 to-purple-600" />
            )}
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40" />
            {/* Content */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center p-8">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 animate-fade-in-up">{slide.title}</h2>
              <p className="text-xl md:text-2xl opacity-90">{slide.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      {data.showArrows !== false && slides.length > 1 && (
        <>
          <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 backdrop-blur rounded-full flex items-center justify-center text-white text-2xl transition">
            ‹
          </button>
          <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 backdrop-blur rounded-full flex items-center justify-center text-white text-2xl transition">
            ›
          </button>
        </>
      )}

      {/* Dots */}
      {data.showDots !== false && slides.length > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
          {slides.map((_, i) => (
            <button 
              key={i} 
              onClick={() => setCurrent(i)}
              className={`w-3 h-3 rounded-full transition-all ${
                i === current ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// Composant Slider Texte avec state interne
const TextSliderPreview = ({ data, primaryColor }) => {
  const [current, setCurrent] = React.useState(0);
  const slides = data.slides || [];
  
  React.useEffect(() => {
    if (!data.autoplay || slides.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, (data.interval || 4) * 1000);
    return () => clearInterval(timer);
  }, [data.autoplay, data.interval, slides.length]);

  if (data.style === 'cards') {
    return (
      <div className="py-16 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="relative overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${current * 100}%)` }}
            >
              {slides.map((slide, i) => (
                <div key={i} className="w-full flex-shrink-0 px-4">
                  <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                    <div className="text-6xl text-indigo-200 mb-4">"</div>
                    <p className="text-xl text-gray-700 italic mb-6">{slide.quote}</p>
                    <div className="flex items-center justify-center gap-4">
                      {slide.avatar ? (
                        <img src={slide.avatar} alt={slide.author} className="w-14 h-14 rounded-full object-cover ring-4 ring-indigo-100" />
                      ) : (
                        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white text-xl font-bold">
                          {slide.author?.charAt(0)}
                        </div>
                      )}
                      <div className="text-left">
                        <div className="font-bold text-gray-900">{slide.author}</div>
                        <div className="text-gray-500 text-sm">{slide.role}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Dots */}
          {slides.length > 1 && (
            <div className="flex justify-center gap-2 mt-8">
              {slides.map((_, i) => (
                <button 
                  key={i} 
                  onClick={() => setCurrent(i)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    i === current ? 'w-8' : ''
                  }`}
                  style={{ backgroundColor: i === current ? primaryColor : '#d1d5db' }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Style minimal
  return (
    <div className="py-16 px-6">
      <div className="max-w-3xl mx-auto text-center relative min-h-[200px]">
        {slides.map((slide, i) => (
          <div 
            key={i}
            className={`absolute inset-0 transition-all duration-500 ${
              i === current ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <div className="text-5xl text-gray-200 mb-4">"</div>
            <p className="text-2xl text-gray-700 italic mb-6">{slide.quote}</p>
            <div className="font-bold text-gray-900">{slide.author}</div>
            <div className="text-gray-500">{slide.role}</div>
          </div>
        ))}
        {/* Navigation */}
        {slides.length > 1 && (
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex gap-2">
            {slides.map((_, i) => (
              <button 
                key={i} 
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all ${
                  i === current ? 'bg-indigo-500 w-6' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// Paramètres d'un bloc
const BlockSettings = ({ block, onChange, primaryColor }) => {
  const { type, data } = block;

  switch(type) {
    case 'header':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700 mb-2">Style de l'entête</div>
          <div>
            <label className="text-sm text-gray-600">Style</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.style || 'modern'} onChange={e => onChange({...data, style: e.target.value})}>
              <option value="modern">Moderne</option>
              <option value="classic">Classique</option>
              <option value="minimal">Minimaliste</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Couleur de fond</label>
            <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.bgColor || '#ffffff'} onChange={e => onChange({...data, bgColor: e.target.value})} />
          </div>
          <div>
            <label className="text-sm text-gray-600">Couleur du texte</label>
            <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.textColor || '#1f2937'} onChange={e => onChange({...data, textColor: e.target.value})} />
          </div>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.sticky ?? true} onChange={e => onChange({...data, sticky: e.target.checked})} />
            <span className="text-sm text-gray-700">Entête fixe</span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.showLogo ?? true} onChange={e => onChange({...data, showLogo: e.target.checked})} />
            <span className="text-sm text-gray-700">Afficher le logo</span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.showNav ?? true} onChange={e => onChange({...data, showNav: e.target.checked})} />
            <span className="text-sm text-gray-700">Afficher la navigation</span>
          </label>
          <div className="border-t pt-4">
            <div className="text-sm font-medium text-gray-700 mb-2">Bouton CTA</div>
            <div>
              <label className="text-sm text-gray-600">Texte du bouton</label>
              <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.ctaText || ''} onChange={e => onChange({...data, ctaText: e.target.value})} placeholder="Contact" />
            </div>
            <div className="mt-2">
              <label className="text-sm text-gray-600">URL du bouton</label>
              <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.ctaUrl || ''} onChange={e => onChange({...data, ctaUrl: e.target.value})} placeholder="#contact" />
            </div>
            <div className="mt-2">
              <label className="text-sm text-gray-600">Couleur du bouton</label>
              <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.ctaBgColor || '#4f46e5'} onChange={e => onChange({...data, ctaBgColor: e.target.value})} />
            </div>
          </div>
        </div>
      );

    case 'button':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Texte du bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.text || ''} onChange={e => onChange({...data, text: e.target.value})} placeholder="Cliquez ici" />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">URL / Lien</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.url || ''} onChange={e => onChange({...data, url: e.target.value})} placeholder="https://..." />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Style</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.style || 'solid'} onChange={e => onChange({...data, style: e.target.value})}>
              <option value="solid">Plein</option>
              <option value="outline">Contour</option>
              <option value="ghost">Fantôme</option>
              <option value="gradient">Dégradé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Taille</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.size || 'lg'} onChange={e => onChange({...data, size: e.target.value})}>
              <option value="sm">Petit</option>
              <option value="md">Moyen</option>
              <option value="lg">Grand</option>
              <option value="xl">Très grand</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Couleur principale</label>
            <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.bgColor || '#4f46e5'} onChange={e => onChange({...data, bgColor: e.target.value})} />
          </div>
          {data.style === 'gradient' && (
            <div>
              <label className="text-sm font-medium text-gray-700">Couleur secondaire</label>
              <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.bgColor2 || '#9333ea'} onChange={e => onChange({...data, bgColor2: e.target.value})} />
            </div>
          )}
          <div>
            <label className="text-sm font-medium text-gray-700">Couleur du texte</label>
            <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.textColor || '#ffffff'} onChange={e => onChange({...data, textColor: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Arrondi ({data.borderRadius || 12}px)</label>
            <input type="range" min="0" max="50" className="w-full" value={data.borderRadius || 12} onChange={e => onChange({...data, borderRadius: parseInt(e.target.value)})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Icône (emoji ou texte)</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.icon || ''} onChange={e => onChange({...data, icon: e.target.value})} placeholder="rocket" />
          </div>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.fullWidth || false} onChange={e => onChange({...data, fullWidth: e.target.checked})} />
            <span className="text-sm text-gray-700">Pleine largeur</span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.animated ?? true} onChange={e => onChange({...data, animated: e.target.checked})} />
            <span className="text-sm text-gray-700">Animation au survol</span>
          </label>
        </div>
      );

    case 'hero':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.title || ''} onChange={e => onChange({...data, title: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Sous-titre</label>
            <textarea className="w-full mt-1 px-3 py-2 border rounded-lg" rows={2} value={data.subtitle || ''} onChange={e => onChange({...data, subtitle: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Gradient</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.bgGradient || ''} onChange={e => onChange({...data, bgGradient: e.target.value})}>
              <option value="from-indigo-600 to-purple-700">Indigo → Violet</option>
              <option value="from-blue-600 to-cyan-500">Bleu → Cyan</option>
              <option value="from-green-500 to-emerald-600">Vert</option>
              <option value="from-orange-500 to-red-600">Orange → Rouge</option>
              <option value="from-gray-800 to-gray-900">Gris foncé</option>
            </select>
          </div>
        </div>
      );

    case 'paragraph':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Texte</label>
            <textarea className="w-full mt-1 px-3 py-2 border rounded-lg" rows={6} value={data.text || ''} onChange={e => onChange({...data, text: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Alignement</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.textAlign || 'left'} onChange={e => onChange({...data, textAlign: e.target.value})}>
              <option value="left">Gauche</option>
              <option value="center">Centre</option>
              <option value="right">Droite</option>
            </select>
          </div>
        </div>
      );

    case 'image':
      return (
        <div className="space-y-4">
          <ImageUploader value={data.url || ''} onChange={url => onChange({...data, url})} label="Image" />
          <div>
            <label className="text-sm font-medium text-gray-700">Texte alt</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.alt || ''} onChange={e => onChange({...data, alt: e.target.value})} />
          </div>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.shadow || false} onChange={e => onChange({...data, shadow: e.target.checked})} />
            <span className="text-sm text-gray-700">Ombre</span>
          </label>
        </div>
      );

    case 'features':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Fonctionnalités</div>
          {(data.items || []).map((item, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <div className="flex gap-2">
                <input className="w-14 px-2 py-1 border rounded text-center" value={item.icon} onChange={e => {
                  const items = [...data.items]; items[i] = {...items[i], icon: e.target.value}; onChange({...data, items});
                }} />
                <input className="flex-1 px-2 py-1 border rounded" placeholder="Titre" value={item.title} onChange={e => {
                  const items = [...data.items]; items[i] = {...items[i], title: e.target.value}; onChange({...data, items});
                }} />
              </div>
              <input className="w-full px-2 py-1 border rounded text-sm" placeholder="Description" value={item.desc} onChange={e => {
                const items = [...data.items]; items[i] = {...items[i], desc: e.target.value}; onChange({...data, items});
              }} />
            </div>
          ))}
        </div>
      );

    case 'cta':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.title || ''} onChange={e => onChange({...data, title: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Sous-titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.subtitle || ''} onChange={e => onChange({...data, subtitle: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Texte bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.buttonText || ''} onChange={e => onChange({...data, buttonText: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">URL bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.buttonUrl || ''} onChange={e => onChange({...data, buttonUrl: e.target.value})} />
          </div>
        </div>
      );

    case 'testimonial':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Citation</label>
            <textarea className="w-full mt-1 px-3 py-2 border rounded-lg" rows={3} value={data.quote || ''} onChange={e => onChange({...data, quote: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Auteur</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.author || ''} onChange={e => onChange({...data, author: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Rôle</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.role || ''} onChange={e => onChange({...data, role: e.target.value})} />
          </div>
        </div>
      );

    case 'contact_form':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.title || ''} onChange={e => onChange({...data, title: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Texte bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.buttonText || ''} onChange={e => onChange({...data, buttonText: e.target.value})} />
          </div>
          <div className="text-xs text-gray-500 bg-blue-50 p-3 rounded-lg">
            ℹ️ Les messages seront envoyés via notification.
          </div>
        </div>
      );

    case 'stats':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Statistiques</div>
          {(data.items || []).map((stat, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg flex gap-2">
              <input className="w-20 px-2 py-1 border rounded text-center font-bold" value={stat.value} onChange={e => {
                const items = [...data.items]; items[i] = {...items[i], value: e.target.value}; onChange({...data, items});
              }} placeholder="100+" />
              <input className="flex-1 px-2 py-1 border rounded" value={stat.label} onChange={e => {
                const items = [...data.items]; items[i] = {...items[i], label: e.target.value}; onChange({...data, items});
              }} placeholder="Clients" />
            </div>
          ))}
          <button onClick={() => onChange({...data, items: [...(data.items || []), { value: '0', label: 'Nouveau' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter une stat
          </button>
        </div>
      );

    case 'pricing':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Plans tarifaires</div>
          {(data.plans || []).map((plan, i) => (
            <div key={i} className={`p-3 rounded-lg ${plan.highlighted ? 'bg-indigo-50 border-2 border-indigo-500' : 'bg-gray-50'}`}>
              <div className="flex gap-2 mb-2">
                <input className="flex-1 px-2 py-1 border rounded font-medium" value={plan.name} onChange={e => {
                  const plans = [...data.plans]; plans[i] = {...plans[i], name: e.target.value}; onChange({...data, plans});
                }} placeholder="Nom du plan" />
                <button onClick={() => {
                  const plans = [...data.plans]; plans[i] = {...plans[i], highlighted: !plans[i].highlighted}; onChange({...data, plans});
                }} className={`px-2 py-1 text-xs rounded ${plan.highlighted ? 'bg-indigo-500 text-white' : 'bg-gray-200'}`}>
                  ★
                </button>
              </div>
              <div className="flex gap-2 mb-2">
                <input className="w-24 px-2 py-1 border rounded text-center font-bold" value={plan.price} onChange={e => {
                  const plans = [...data.plans]; plans[i] = {...plans[i], price: e.target.value}; onChange({...data, plans});
                }} placeholder="49F" />
                <input className="flex-1 px-2 py-1 border rounded text-sm" value={plan.period} onChange={e => {
                  const plans = [...data.plans]; plans[i] = {...plans[i], period: e.target.value}; onChange({...data, plans});
                }} placeholder="/mois" />
              </div>
              <textarea className="w-full px-2 py-1 border rounded text-sm mb-2" rows={3} value={(plan.features || []).join('\n')} onChange={e => {
                const plans = [...data.plans]; plans[i] = {...plans[i], features: e.target.value.split('\n')}; onChange({...data, plans});
              }} placeholder="Une feature par ligne" />
              <div className="border-t pt-2 mt-2">
                <div className="text-xs font-medium text-gray-500 mb-1">Bouton d'action</div>
                <div className="flex gap-2 mb-2">
                  <input className="flex-1 px-2 py-1 border rounded text-sm" value={plan.buttonText || ''} onChange={e => {
                    const plans = [...data.plans]; plans[i] = {...plans[i], buttonText: e.target.value}; onChange({...data, plans});
                  }} placeholder="Texte bouton" />
                </div>
                <input className="w-full px-2 py-1 border rounded text-sm" value={plan.buttonUrl || ''} onChange={e => {
                  const plans = [...data.plans]; plans[i] = {...plans[i], buttonUrl: e.target.value}; onChange({...data, plans});
                }} placeholder="URL du bouton (ex: /contact)" />
              </div>
            </div>
          ))}
        </div>
      );

    case 'gallery':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Colonnes</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.columns || 3} onChange={e => onChange({...data, columns: parseInt(e.target.value)})}>
              <option value={2}>2 colonnes</option>
              <option value={3}>3 colonnes</option>
              <option value={4}>4 colonnes</option>
            </select>
          </div>
          <div className="text-sm font-medium text-gray-700">Images</div>
          {(data.images || []).map((img, i) => (
            <div key={i} className="flex gap-2 items-center">
              <img src={img} alt="" className="w-12 h-12 object-cover rounded" />
              <input className="flex-1 px-2 py-1 border rounded text-sm" value={img} onChange={e => {
                const images = [...data.images]; images[i] = e.target.value; onChange({...data, images});
              }} />
              <button onClick={() => {
                const images = data.images.filter((_, j) => j !== i); onChange({...data, images});
              }} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <ImageUploader value="" onChange={url => onChange({...data, images: [...(data.images || []), url]})} label="Ajouter une image" />
        </div>
      );

    case 'youtube':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">URL YouTube</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.url || ''} onChange={e => onChange({...data, url: e.target.value})} placeholder="https://youtube.com/watch?v=..." />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Format</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.aspect || '16/9'} onChange={e => onChange({...data, aspect: e.target.value})}>
              <option value="16/9">16:9 (Standard)</option>
              <option value="4/3">4:3</option>
              <option value="1/1">1:1 (Carré)</option>
            </select>
          </div>
        </div>
      );

    case 'divider':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Style</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.style || 'line'} onChange={e => onChange({...data, style: e.target.value})}>
              <option value="line">Ligne simple</option>
              <option value="dots">Points</option>
              <option value="wave">Vague</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Espacement</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.spacing || 'md'} onChange={e => onChange({...data, spacing: e.target.value})}>
              <option value="sm">Petit</option>
              <option value="md">Moyen</option>
              <option value="lg">Grand</option>
            </select>
          </div>
        </div>
      );

    case 'countdown':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.title || ''} onChange={e => onChange({...data, title: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Date cible</label>
            <input type="date" className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.targetDate || ''} onChange={e => onChange({...data, targetDate: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Couleur</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.bgGradient || ''} onChange={e => onChange({...data, bgGradient: e.target.value})}>
              <option value="from-red-500 to-orange-500">Rouge → Orange</option>
              <option value="from-indigo-500 to-purple-600">Indigo → Violet</option>
              <option value="from-green-500 to-teal-500">Vert → Teal</option>
              <option value="from-pink-500 to-rose-500">Rose</option>
              <option value="from-gray-700 to-gray-900">Gris foncé</option>
            </select>
          </div>
        </div>
      );

    case 'faq':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Questions / Réponses</div>
          {(data.items || []).map((item, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <input className="w-full px-2 py-1 border rounded font-medium" placeholder="Question" value={item.q} onChange={e => {
                const items = [...data.items]; items[i] = {...items[i], q: e.target.value}; onChange({...data, items});
              }} />
              <textarea className="w-full px-2 py-1 border rounded text-sm" rows={2} placeholder="Réponse" value={item.a} onChange={e => {
                const items = [...data.items]; items[i] = {...items[i], a: e.target.value}; onChange({...data, items});
              }} />
              <button onClick={() => {
                const items = data.items.filter((_, j) => j !== i); onChange({...data, items});
              }} className="text-red-500 text-sm flex items-center gap-1"><Trash2 className="w-4 h-4" /> Supprimer</button>
            </div>
          ))}
          <button onClick={() => onChange({...data, items: [...(data.items || []), { q: '', a: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter une question
          </button>
        </div>
      );

    case 'team':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Membres de l'équipe</div>
          {(data.members || []).map((m, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <input className="w-full px-2 py-1 border rounded font-medium" placeholder="Nom" value={m.name} onChange={e => {
                const members = [...data.members]; members[i] = {...members[i], name: e.target.value}; onChange({...data, members});
              }} />
              <input className="w-full px-2 py-1 border rounded text-sm" placeholder="Rôle" value={m.role} onChange={e => {
                const members = [...data.members]; members[i] = {...members[i], role: e.target.value}; onChange({...data, members});
              }} />
              <input className="w-full px-2 py-1 border rounded text-sm" placeholder="Bio courte" value={m.bio} onChange={e => {
                const members = [...data.members]; members[i] = {...members[i], bio: e.target.value}; onChange({...data, members});
              }} />
              <ImageUploader value={m.image || ''} onChange={url => {
                const members = [...data.members]; members[i] = {...members[i], image: url}; onChange({...data, members});
              }} label="Photo" />
            </div>
          ))}
          <button onClick={() => onChange({...data, members: [...(data.members || []), { name: '', role: '', bio: '', image: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter un membre
          </button>
        </div>
      );

    case 'logos':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Titre</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.title || ''} onChange={e => onChange({...data, title: e.target.value})} placeholder="Ils nous font confiance" />
          </div>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.grayscale ?? true} onChange={e => onChange({...data, grayscale: e.target.checked})} />
            <span className="text-sm text-gray-700">Niveaux de gris</span>
          </label>
          <div className="text-sm font-medium text-gray-700">Logos (URLs)</div>
          {(data.logos || []).map((logo, i) => (
            <div key={i} className="flex gap-2">
              <input className="flex-1 px-2 py-1 border rounded text-sm" value={logo} onChange={e => {
                const logos = [...data.logos]; logos[i] = e.target.value; onChange({...data, logos});
              }} />
              <button onClick={() => {
                const logos = data.logos.filter((_, j) => j !== i); onChange({...data, logos});
              }} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <ImageUploader value="" onChange={url => onChange({...data, logos: [...(data.logos || []), url]})} label="Ajouter un logo" />
        </div>
      );

    case 'social':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Réseaux sociaux</div>
          {(data.links || []).map((link, i) => (
            <div key={i} className="flex gap-2">
              <select className="px-2 py-1 border rounded" value={link.platform} onChange={e => {
                const links = [...data.links]; links[i] = {...links[i], platform: e.target.value}; onChange({...data, links});
              }}>
                <option value="facebook">Facebook</option>
                <option value="instagram">Instagram</option>
                <option value="twitter">Twitter/X</option>
                <option value="linkedin">LinkedIn</option>
                <option value="youtube">YouTube</option>
                <option value="tiktok">TikTok</option>
                <option value="github">GitHub</option>
                <option value="discord">Discord</option>
              </select>
              <input className="flex-1 px-2 py-1 border rounded text-sm" placeholder="URL" value={link.url} onChange={e => {
                const links = [...data.links]; links[i] = {...links[i], url: e.target.value}; onChange({...data, links});
              }} />
              <button onClick={() => {
                const links = data.links.filter((_, j) => j !== i); onChange({...data, links});
              }} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <button onClick={() => onChange({...data, links: [...(data.links || []), { platform: 'facebook', url: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter un réseau
          </button>
        </div>
      );

    case 'map':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Adresse</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.address || ''} onChange={e => onChange({...data, address: e.target.value})} placeholder="Paris, France" />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Zoom ({data.zoom || 14})</label>
            <input type="range" min="10" max="18" className="w-full" value={data.zoom || 14} onChange={e => onChange({...data, zoom: parseInt(e.target.value)})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Hauteur (px)</label>
            <input type="number" className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.height || 400} onChange={e => onChange({...data, height: parseInt(e.target.value)})} />
          </div>
        </div>
      );

    case 'banner':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Texte</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.text || ''} onChange={e => onChange({...data, text: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Texte bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.buttonText || ''} onChange={e => onChange({...data, buttonText: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">URL bouton</label>
            <input className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.buttonUrl || ''} onChange={e => onChange({...data, buttonUrl: e.target.value})} />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Couleur de fond</label>
            <input type="color" className="w-full h-10 rounded cursor-pointer" value={data.bgColor || '#ef4444'} onChange={e => onChange({...data, bgColor: e.target.value})} />
          </div>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={data.animated ?? true} onChange={e => onChange({...data, animated: e.target.checked})} />
            <span className="text-sm text-gray-700">Animation pulsation</span>
          </label>
        </div>
      );

    case 'timeline':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Événements</div>
          {(data.events || []).map((evt, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <div className="flex gap-2">
                <input className="w-20 px-2 py-1 border rounded text-center font-bold" placeholder="Année" value={evt.year} onChange={e => {
                  const events = [...data.events]; events[i] = {...events[i], year: e.target.value}; onChange({...data, events});
                }} />
                <input className="flex-1 px-2 py-1 border rounded font-medium" placeholder="Titre" value={evt.title} onChange={e => {
                  const events = [...data.events]; events[i] = {...events[i], title: e.target.value}; onChange({...data, events});
                }} />
              </div>
              <input className="w-full px-2 py-1 border rounded text-sm" placeholder="Description" value={evt.desc} onChange={e => {
                const events = [...data.events]; events[i] = {...events[i], desc: e.target.value}; onChange({...data, events});
              }} />
              <button onClick={() => {
                const events = data.events.filter((_, j) => j !== i); onChange({...data, events});
              }} className="text-red-500 text-sm flex items-center gap-1"><Trash2 className="w-4 h-4" /> Supprimer</button>
            </div>
          ))}
          <button onClick={() => onChange({...data, events: [...(data.events || []), { year: '', title: '', desc: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter un événement
          </button>
        </div>
      );

    case 'image_slider':
      return (
        <div className="space-y-4">
          <div className="text-sm font-medium text-gray-700">Slides</div>
          {(data.slides || []).map((slide, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-medium text-gray-500">Slide {i + 1}</span>
                <button onClick={() => {
                  const slides = data.slides.filter((_, j) => j !== i); onChange({...data, slides});
                }} className="text-red-500 text-sm"><Trash2 className="w-4 h-4" /></button>
              </div>
              <ImageUploader value={slide.image || ''} onChange={url => {
                const slides = [...data.slides]; slides[i] = {...slides[i], image: url}; onChange({...data, slides});
              }} label="Image" />
              <input className="w-full px-2 py-1 border rounded font-medium" placeholder="Titre" value={slide.title || ''} onChange={e => {
                const slides = [...data.slides]; slides[i] = {...slides[i], title: e.target.value}; onChange({...data, slides});
              }} />
              <input className="w-full px-2 py-1 border rounded text-sm" placeholder="Sous-titre" value={slide.subtitle || ''} onChange={e => {
                const slides = [...data.slides]; slides[i] = {...slides[i], subtitle: e.target.value}; onChange({...data, slides});
              }} />
            </div>
          ))}
          <button onClick={() => onChange({...data, slides: [...(data.slides || []), { image: '', title: 'Nouveau slide', subtitle: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter un slide
          </button>
          
          <div className="border-t pt-4 mt-4">
            <div className="text-sm font-medium text-gray-700 mb-3">Options</div>
            <div className="space-y-3">
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={data.autoplay ?? true} onChange={e => onChange({...data, autoplay: e.target.checked})} />
                <span className="text-sm text-gray-700">Lecture automatique</span>
              </label>
              {data.autoplay && (
                <div>
                  <label className="text-sm text-gray-600">Intervalle ({data.interval || 5}s)</label>
                  <input type="range" min="2" max="10" className="w-full" value={data.interval || 5} onChange={e => onChange({...data, interval: parseInt(e.target.value)})} />
                </div>
              )}
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={data.showArrows ?? true} onChange={e => onChange({...data, showArrows: e.target.checked})} />
                <span className="text-sm text-gray-700">Afficher les flèches</span>
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={data.showDots ?? true} onChange={e => onChange({...data, showDots: e.target.checked})} />
                <span className="text-sm text-gray-700">Afficher les points</span>
              </label>
              <div>
                <label className="text-sm text-gray-600">Hauteur (px)</label>
                <input type="number" className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.height || 500} onChange={e => onChange({...data, height: parseInt(e.target.value)})} />
              </div>
            </div>
          </div>
        </div>
      );

    case 'text_slider':
      return (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Style</label>
            <select className="w-full mt-1 px-3 py-2 border rounded-lg" value={data.style || 'cards'} onChange={e => onChange({...data, style: e.target.value})}>
              <option value="cards">Cartes</option>
              <option value="minimal">Minimal</option>
            </select>
          </div>
          
          <div className="text-sm font-medium text-gray-700">Témoignages</div>
          {(data.slides || []).map((slide, i) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg space-y-2">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-medium text-gray-500">Témoignage {i + 1}</span>
                <button onClick={() => {
                  const slides = data.slides.filter((_, j) => j !== i); onChange({...data, slides});
                }} className="text-red-500 text-sm"><Trash2 className="w-4 h-4" /></button>
              </div>
              <textarea className="w-full px-2 py-1 border rounded text-sm" rows={3} placeholder="Citation" value={slide.quote || ''} onChange={e => {
                const slides = [...data.slides]; slides[i] = {...slides[i], quote: e.target.value}; onChange({...data, slides});
              }} />
              <div className="grid grid-cols-2 gap-2">
                <input className="px-2 py-1 border rounded text-sm" placeholder="Auteur" value={slide.author || ''} onChange={e => {
                  const slides = [...data.slides]; slides[i] = {...slides[i], author: e.target.value}; onChange({...data, slides});
                }} />
                <input className="px-2 py-1 border rounded text-sm" placeholder="Rôle" value={slide.role || ''} onChange={e => {
                  const slides = [...data.slides]; slides[i] = {...slides[i], role: e.target.value}; onChange({...data, slides});
                }} />
              </div>
              <ImageUploader value={slide.avatar || ''} onChange={url => {
                const slides = [...data.slides]; slides[i] = {...slides[i], avatar: url}; onChange({...data, slides});
              }} label="Avatar (optionnel)" />
            </div>
          ))}
          <button onClick={() => onChange({...data, slides: [...(data.slides || []), { quote: '', author: '', role: '', avatar: '' }]})} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:border-indigo-500 hover:text-indigo-500">
            + Ajouter un témoignage
          </button>
          
          <div className="border-t pt-4 mt-4">
            <div className="text-sm font-medium text-gray-700 mb-3">Options</div>
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={data.autoplay ?? true} onChange={e => onChange({...data, autoplay: e.target.checked})} />
              <span className="text-sm text-gray-700">Lecture automatique</span>
            </label>
            {data.autoplay && (
              <div className="mt-2">
                <label className="text-sm text-gray-600">Intervalle ({data.interval || 4}s)</label>
                <input type="range" min="2" max="10" className="w-full" value={data.interval || 4} onChange={e => onChange({...data, interval: parseInt(e.target.value)})} />
              </div>
            )}
          </div>
        </div>
      );

    default:
      return <div className="text-sm text-gray-500">Pas de paramètres</div>;
  }
};

export default ShowcaseEditor;
